//配置信息
// import conditionMethod from "../utils/conditionMethod.js";

//是否线上
// export const ONLINE = conditionMethod.isOnline();

export const IS_TEST = false;

//注册接口（个人测试）
export const REGISTER = "/register";

//车辆订单状态
export const ORDER_STATUS_SUCCESS = 20; //已支付
export const ORDER_STATUS_ARREARS = 50; //欠费
export const ORDER_STATUS_FAILURE = 14; //支付失败
export const ORDER_STATUS_ABNORMAL = 10; //支付中
export const ORDER_STATUS_PENDING = 0;
export const PAY_SUCCESS = 20;
export const PAY_FAILURE = 14;

//收费/欠费记录页面点击记录查看详情接口
export const ORDER_PARKING_FIND_ORDER_PARKING_BY_ID =
  "/order-parking/findOrderParkingById";

export const PARKING_SPACE_ENTER_OPERATOR_AGAIN =
  "/parking-space/enter-operator-again";

export const ORDER_PARKING_CONFIRM_IS_LEAVE = "/order-parking/confirmIsLeave";

//收费/欠费记录列表
export const ORDER_PAKING = "/order-parking";

//取消订单
export const ORDER_PARKING_CANCEL_ORDER = "/order-parking/cancelOrder";

//订单欠费操作
export const ORDER_PARKING_ARREAR_OPERATE = "/order-parking/arrear-operate";

//待处理状态查询已生成的待处理的订单
export const ORDER_PARKING_FIND_ORDER_PARKING_OF_WAIT_HANDLE =
  "/order-parking/findOrderParkingOfWaitHandle";

//车牌照扫描检查是否有欠费订单
export const ORDER_PARKING_ARREARS_ORDER_PARKING_LIST =
  "/order-parking/arrearsOrderParkingList";

//用户修改密码
export const EMPLOYEE_UPDATE_PASSWORD = "/employee/updatePassword";

//轮询查找订单状态
export const ORDER_PARKING_GET_ORDER_STATUS = "/order-parking/getOrderStatus";

//扫描二维码
export const ORDER_PARKING_SCANCODE_PAY = "/order-parking/scancode-pay";

//生成二维码
export const ORDER_PARKING_QRCODE = "/order-parking/qrcode";

//线下支付
export const ORDER_PARKING_OFFLINE_PAY = "/order-parking/offlinePay";

//无费用订单确认订单结束操作
export const ORDER_PARKING_FINISH = "/order-parking/finish";

//异常订单记录查询
export const ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST =
  "/order-parking/exceptionOrderParkingList";

//补缴扫描二维码收款
export const ORDER_PARKING_RECOVERY_SCANCODE_PAY =
  "/order-parking/recovery-scancode-pay";

//补缴生成订单二维码
export const ORDER_PARKING_RECOVERY_QRCODE = "/order-parking/recovery-qrcode";

//更新订单状态
export const ORDER_PARKING_SYNC_ORDER_INFO = "/order-parking/sync-order-info";

//更新失败订单状态
export const ORDER_PARKING_UPDATE_PAY_FAIL_ORDER =
  "/order-parking/updatePayFailOrder";

export const ORDER_PARKING_CHECK_PAY_IS_ALLOWED = `/order-parking/checkPayIsAllowed`;

export const ORDER_PARKING_GET_PREPAY_AMOUNT_LIST =
  "/order-parking/getPrePayAmountList"; //获取预付费金额列表

export const ORDER_PARKING_SET_PREPAY_AMOUNT = "/order-parking/setPrePayAmount"; //设置预付费金额

export const ORDER_PARKING_REFUND = "/order-parking/refund";

export const ORDER_PARKING_FIND_UNHANDLE_ORDER_PARKING_BY_ID =
  "/order-parking/findUnhandleOrderParkingById"; //获取未处理订单信息

export const ORDER_PARKING_ORDER_FLOW_PARKING_LIST =
  "/order-parking/orderFlowParkingList"; // 查询订单流水

//请求成功状态码
export const REQUEST_SUCCESS_CODE = 1;

//请求失败信息提示
export const REQUEST_FAILURE_MSG = "获取信息失败，请重试";
export const ABNORMAL_ORDER_MSG = "该订单状态异常";

//车类型vehicleType 10 普通
export const VEHICLE_TYPE_ARR = [
  { code: 10, text: "普通" },
  { code: 20, text: "免费" },
  { code: 30, text: "预付" },
  { code: 40, text: "欠费" }
];

//支付方式列表
export const PAYWAY_TYPE_ARR = [
  { code: 0, text: "免费车" },
  { code: 1, text: "白名单" },
  { code: 2, text: "零费用" },
  { code: 10, text: "支付宝" },
  { code: 11, text: "微信支付" },
  { code: 12, text: "银联支付" },
  { code: 13, text: "建设银行" },
  { code: 20, text: "已支付" },
  { code: 30, text: "预付卡" },
  { code: 33, text: "退款" },
  { code: 40, text: "线下支付" },
  { code: 50, text: "欠费" },
  { code: 60, text: "补缴" }
];
